import type { PropsWithChildren } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from '../store/store';

/**
 * Providers transverses de l'application (store, thème, i18n…).
 * C'est ici que s'ajouteront les futurs providers globaux.
 */
export function AppProviders({ children }: PropsWithChildren) {
  return <ReduxProvider store={store}>{children}</ReduxProvider>;
}
